module.exports = __webpack_public_path__ + "static/media/hiw-time.7cb4c1c5.svg";